import { Attribute, ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'label[emsysLabel], form-label',
    template: '<ng-content></ng-content>',
    styleUrls: ['./form-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormLabelComponent {

  constructor(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    @Attribute('for') forHtml: string,
  ) { }

}
